import { gql } from "@codesandbox/api";
import useSWR from "swr";

import { useCsbApi } from "./api/useCsbApi";

export type UseWorkspacesOfBranchParams = {
  owner: string;
  repo: string;
  branch: string;
};

const workspacesOfBranchQuery = gql.createQuery(
  "WorkspacesOfBranch",
  ({ owner, repo, branch }: UseWorkspacesOfBranchParams) => ({
    "workspaces:projects": [
      { owner, name: repo, provider: gql.GitProvider.GITHUB },
      {
        team: {
          id: true,
          name: true,
          avatarUrl: true,
        },
        "branch:branchByName": [
          { name: branch },
          {
            id: true,
          },
        ],
      },
    ],
  }),
);

export const useWorkspacesOfBranch = ({
  owner,
  repo,
  branch,
}: UseWorkspacesOfBranchParams) => {
  const csbApi = useCsbApi();
  const { data } = useSWR(
    `workspaces-of-branch-${owner}/${repo}/${branch}`,
    () =>
      csbApi.gql.query(workspacesOfBranchQuery, {
        owner,
        repo,
        branch,
      }),
  );

  if (!data) {
    return undefined;
  }

  return data.workspaces
    .filter((workspace) => Boolean(workspace.branch))
    .map((workspace) => ({
      name: workspace.team?.name ?? "Public",
      id: workspace.team?.id ?? null,
      avatarUrl: workspace.team?.avatarUrl ?? null,
    }));
};
